import React, { Suspense, useCallback } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { abjwt } from '@applyboard/ui-utils';
import { IRoute } from './config';

// eslint-disable-next-line no-unused-vars
interface CustomWindow extends Window {
  API_ROOT?: string;
}

declare let window: CustomWindow;

const RouteWithSubRoutes = (route: IRoute) => {
  const authenticated: boolean = abjwt.isLoggedIn();

  const reroute = useCallback(
    ({ location, ...props }) => {
      if (route.redirect) {
        return <Redirect to={route.redirect} />;
      }

      if (route.private) {
        if (authenticated) {
          return route.component && <route.component {...props} routes={route.routes} />;
        }

        /*
          set window location to create a new request on the host, allowing the reverse proxy to
          redirect to the monorepo
        */
        const API_ROOT = window.API_ROOT || '';
        const redirectTo = encodeURIComponent(location.pathname);
        window.location.href = `${API_ROOT}/login?redirect_to=${redirectTo}`;
        return null;
      }

      return route.component && <route.component {...props} routes={route.routes} />;
    },
    [route],
  );

  return (
    <Suspense fallback={route.fallback || <FooterPusher />}>
      <Route path={route.path} render={reroute} />
    </Suspense>
  );
};

function FooterPusher() {
  return <div style={{ height: '100%' }}></div>;
}

export default RouteWithSubRoutes;
